module.exports = __webpack_public_path__ + "static/media/GreeceBlocks_2_2_drag_1.69d2bfc8.png";